// import React, { useState } from "react";
// import { Helmet } from "react-helmet"; // Helmet import

import RandingStyle13 from "../../randing/RandingStyle13";

function Randing042({ urlCode, urlCodeSettingId }) {
  const treatments = [
    { value: "5a36ef1e-bc09-4905-b663-035e11d6dd40", label: "임플)33M" },
    { value: "57458162-e0ea-4295-b839-c2d44fe58e75", label: "임플)38M" },
  ];
  return (
    <RandingStyle13
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/042/24123001.jpg`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/042/24123002.png`}
      img10Path={`${process.env.REACT_APP_CDN_BASE}/images/042/24123003.gif`} //질문 밑에 이미지라서 10이상으로 지정
      img11Path={`${process.env.REACT_APP_CDN_BASE}/images/042/24123004.jpg`}
      step1Title={`${process.env.REACT_APP_CDN_BASE}/images/042/24123005.jpg`}
      step2Title={`${process.env.REACT_APP_CDN_BASE}/images/042/24123006.jpg`}
      step3Title={`${process.env.REACT_APP_CDN_BASE}/images/042/24123007.jpg`}
      step1Options={`${process.env.REACT_APP_CDN_BASE}/images/042/step1`}
      step2Options={`${process.env.REACT_APP_CDN_BASE}/images/042/step2`}
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/applyButton2.png`}
      companyName="광교365리움치과병원"
      callNumber={"tel:1533-1428"}
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/gwanggyo.jpg`}
      eventDates={true}
      treatments={treatments}
    />
  );
}

export default Randing042;
